module.exports = __webpack_public_path__ + "img/identity-camera.e226aa9d.png";